import { SurveyCreatorComponent, SurveyCreator } from '@navriti/forms';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { Modal, Button, TextInput, Flex, Image } from '@mantine/core';
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
import { SAVE_TEMPLATE_URL, MESSAGES } from '../messages.js/templateCreateTexts'; // Import constants and messages from config.js
import logo from '../../assets/logo.png';
const creatorOptions = {
  showLogicTab: true,
  isAutoSave: true,
};
const defaultJson = {
  title: 'Template Title',
  pages: [{
    name: "Name",
    elements: [{
      name: "FirstName",
      title: "Enter your first name:",
      type: "text"
    },{
      name: "LastName",
      title: "Enter your last name:",
      type: "text"
    }]
  }]
};

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export default function TemplateCreatorWidget() {
  const [link, setLink] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate

  const creator = new SurveyCreator(creatorOptions);
  const hiddenTypes = [
      "multipletext",
      "paneldynamic",
      "matrix",
      "matrixdropdown",
      "matrixdynamic",
      "matrixrating",
      "imagepicker"
    ];

    hiddenTypes.forEach(type => {
      creator.toolbox.removeItem(type);
    });

   // ✅ Auto-trim survey description to max 1000 characters
        creator.onPropertyValueChanging?.add((sender, options) => {
          if (options.propertyName === "description") {
            const maxLength = 1000;
            const newValue = options.newValue || "";

            if (newValue.length > maxLength) {
              options.newValue = newValue.substring(0, maxLength);
              toast.warn("Description trimmed to 1000 characters.");
            }
          }
        });
  creator.text = window.localStorage.getItem("survey-json") || JSON.stringify(defaultJson);

  useEffect(() => {
    setModalIsOpen(true); // Open modal on component mount for template creation
  }, []);

  const saveTemplateData = async (isDraft) => {
    try {
      const token = getCookie('token');
      const creatorJSON = JSON.parse(creator.text);
      const response = await fetch(SAVE_TEMPLATE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        credentials: 'include',
        body: JSON.stringify({
          TemplateData: creatorJSON,
          TemplateName: creatorJSON['title'],
          isDraft: isDraft
        })
      });
      if (response.ok) {
        toast.success(MESSAGES.SUCCESS_SAVE, {
          onClose: () => navigate('/') // Navigate to home.jsx after successful toast
        });
        let res = await response.json();
      } else {
        toast.error(MESSAGES.ERROR_SAVE_FAIL);
      }
    } catch (error) {
      console.error("Error saving template data:", error);
      toast.error(MESSAGES.ERROR_SAVE);
    }
  };

  const handleModalClose = () => {
    setModalIsOpen(false);
  };

  const handleSubmitModal = () => {
    setModalIsOpen(false);
  };

  const handleSaveButtonClick = () => {
    saveTemplateData(false);
  };

  const handleSaveDraftButtonClick = () => {
    saveTemplateData(true);
  };
  

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 24px',
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #ddd',
      boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      position: 'sticky',
      top: 0,
      zIndex: 10,
      height: '60px',
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <Flex align="center">
        <a href="/"><Image src={logo} height={50} width={50} /></a>
      </Flex>
      <h2 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 600, color: '#333' }}>
        Template Builder
      </h2>
    </div>

    <div style={{ display: 'flex', gap: '6px', flexShrink: 0, height: '60%' }}>
      <Button
        onClick={() => navigate('/', { state: { navItem: 'Templates' }, replace: true })}
        variant='outline'
        style={{ borderRadius: '9px', height: '100%' }}
      >
        Back to Templates
      </Button>

      <Button
        onClick={handleSaveDraftButtonClick}
        variant='outline'
        style={{ borderRadius: '9px', height: '100%' }}
      >
        Save as Draft
      </Button>

      <Button
        onClick={handleSaveButtonClick}
        variant='outline'
        style={{ borderRadius: '9px', height: '100%' }}
      >
        Save Template
      </Button>
    </div>
  </div>

  <div style={{ flex: 1 }}>
    <SurveyCreatorComponent creator={creator} />
  </div>

  <ToastContainer />
</div>

  );
}
